<template>
  <template v-if="isLoading || isUpdating">
    <loading :isLoading="isLoading" :message="'処理中...'"></loading>
  </template>
  <template v-if="!isLoading && !isUpdating">
    <div class="form-item">
      <textarea v-model="syuuseiData.notes" :error="getError(syuuseiData.notes, '')"></textarea>
    </div>
    <div class="buttons">
      <button type="button" class="btn success" @click="update()"><i class="fa-solid fa-check"></i>更新</button>
      <button type="button" class="btn cancel" @click="cancel()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
</template>

<script lang="ts">
import { useKoyouKeiyakuNotesUpdate } from '@/composable/syain/detail/koyoukeiyaku-notes-update';
import { KoyouKeiyakuNotesData } from '@/composable/modal/koyoukeiyaku-notes-syuusei';
import { computed, defineComponent, ref } from 'vue';
import { useForm } from "@/composable/form/form";

export default defineComponent({
  props: {
    syuuseiData: {
      type: Object as () => KoyouKeiyakuNotesData,
      default: null
    },
    userId: {
      type: Number,
      require: true
    },
  },
  emits: {
    send: (result: boolean) => true,
    cancel: () => true,
  },
  setup(props, context) {
    const { updateKoyouKeiyakuNotes, isLoading } = useKoyouKeiyakuNotesUpdate()
    const { getError } = useForm();
    const isUpdating = ref(false)

    const update = async () => {
      isUpdating.value = true
      if (!props.userId) {
        return
      }

      try {
        await updateKoyouKeiyakuNotes(props.userId, props.syuuseiData.notes);
        context.emit('send', true);
      } catch (e) {
        console.error(e);
      } finally {
        isUpdating.value = false
      }
    }

    const cancel = () => {
      context.emit('cancel');
    }

    const syuuseiData = computed(() => {
      return props.syuuseiData
    })

    return {
      update,
      cancel,
      close,
      syuuseiData,
      isLoading,
      isUpdating,
      getError,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/dialog/koyoukeiyaku-notes-syuusei.scss';
</style>